<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>スポット</title-bar>
    <!-- <action-nav /> -->
    <b-form-group id="name" label="スポット名">
      <b-form-input placeholder="" v-model="form.name"></b-form-input>
    </b-form-group>
    <b-form-group id="location" label="場所">
      {{ location }}
    </b-form-group>
    <b-form-group id="bg" label="背景">
      <b-form-input placeholder="" v-model="form.bg" debounce="500" />
      <b-img width="250px" height="75px" :src="form.bg" fluid />
    </b-form-group>
    <b-form-group id="option" label="オプション">
      <b-form-checkbox v-model="form.indoor"
        :value="1" :unchecked-value="0">
        屋内
      </b-form-checkbox>
      <b-form-checkbox v-model="form.lockEvent"
        :value="1" :unchecked-value="0">
        イベントを作成できるのは自分だけ
      </b-form-checkbox>
    </b-form-group>

    <b-form-group v-if="form.rid !== 'new'"
      id="world" label="異世界への入口" 
    >
      <p class="link-world">
        <b-table-simple hover small>
          <b-thead>
            <b-tr>
              <b-th>世界名</b-th>
              <b-th>条件</b-th>
              <b-th>初期位置</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr variant="light" v-for="(w,index) in form.link" :key="index">
              <b-td>
                <b-button class="p-1" @click="$delete(form.link, index)">
                  <font-awesome-icon icon="times" class="fa-1x" />
                </b-button>
                <router-link :to="{ path:`world-edit/${w.to}` }">
                  {{ world[w.to].name }}
                  <font-awesome-icon icon="pen" class="icon fa-sx" />
                </router-link>
              </b-td>
              <b-td>
                <b-container>
                  <template v-for="(val,key) in w">
                    <b-row v-if="key !== 'to' && key !== 'init'" :key="key">
                      <b-col>{{ key }}が{{ val }}以上</b-col>
                    </b-row>
                  </template>
                </b-container>
              </b-td>
              <b-td>
                <b-container>
                  <b-row v-for="pos in w.init" :key="pos">
                    <b-col>{{ world[w.to].field[pos].name }}</b-col>
                  </b-row>
                </b-container>
              </b-td>
            </b-tr>
            <b-tr variant="info">
              <b-td>
                <b-form-select v-model="addLinkKey" :options="worldList" >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>--- 行先を選択 ---</b-form-select-option>
                  </template>
                </b-form-select>
                <b-button @click="addLink" variant="success" :disabled="!addLinkKey || initPosKey.length == 0">
                  <font-awesome-icon icon="plus-square" class="fa-1x"/>
                  道を追加
                </b-button>
              </b-td>
              <b-td>
                <b-container>
                  <b-row v-for="(cond,index) in linkCondition" :key="index">
                    <b-col cols="1" class="p-0">
                      <b-button class="p-1" @click="$delete(linkCondition, index)">
                        <font-awesome-icon icon="times" class="fa-1x" />
                      </b-button>
                    </b-col>
                    <b-col cols="3" class="p-0"><b-form-input v-model="cond.key" /></b-col>
                    <b-col cols="1" class="p-0">が</b-col>
                    <b-col cols="3" class="p-0"><b-form-input type="number" v-model="cond.value" /></b-col>
                    <b-col cols="2" class="p-0">以上</b-col>
                  </b-row>
                </b-container>
                <b-button @click="linkCondition.push({key:'',value:1})">
                  <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
                  追加
                </b-button>
              </b-td>
              <b-td>
                <b-container>
                  <b-row  v-for="(cond,index) in initPosKey" :key="index">
                    <b-col cols="1">
                      <b-button class="p-1" @click="$delete(initPosKey, index)">
                        <font-awesome-icon icon="times" class="fa-1x" />
                      </b-button>
                    </b-col>
                    <b-col class="p-1">
                      {{ world[addLinkKey].field[initPosKey[index]].name }}
                    </b-col>
                  </b-row>
                </b-container>
                <b-form-select v-model="addLinkInitKey" :options="fieldList" >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>--- 初期位置を選択 ---</b-form-select-option>
                  </template>
                </b-form-select>
                <b-button @click="initPosKey.push(addLinkInitKey); addLinkInitKey = null" :disabled="!addLinkKey">
                  <font-awesome-icon icon="plus-square" class="fa-1x"/>
                  初期位置を追加
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </p>
    </b-form-group>
    <p class="m-2">
      <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
      <response-message :value="postMessage" />
    </p>
  </WhitePage>
</template>
'
<script>
import { phina } from '@/canvas'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
// import RemarkEditor from '@/components/RemarkEditor'
// import IconDropdown from '@/components/IconDropdown'
// import ActionNav from '@/components/ActionNav'
import ResponseMessage from '@/components/ResponseMessage'
// import CodeEditor from '@/components/CodeEditor'
import _ from 'lodash'
export default {
  components: {
    WhitePage,
    TitleBar,
    // RemarkEditor,
    // IconDropdown,
    // ActionNav,
    ResponseMessage,
    // CodeEditor
  },
  computed: {
    worldList () {
      return _.map(_.keys(this.world), (key)=>{
        return { value:key, text:this.world[key].name }
      }) 
    },
    fieldList () {
      let list = []
      if(this.addLinkKey){
        let f = this.world[this.addLinkKey].field
        list = _.map(_.filter(_.keys(f),(k)=>{return !f[k].spot}),
          (key)=>{return { value:key, text:f[key].name } })
      }
      return list
    }
  },
  data () {
    return {
      location: '',
      addLinkKey: null,
      addLinkInitKey: null,
      linkCondition: [],
      initPosKey: [],
      form: {
        name: '',
        bg: '',
        indoor: 0,
        rid: '',
        lockEvent: 0,
        link: [],
      },
      loading: false,
      postMessage: {},
      world: {}
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.form.name = response.name
      this.form.bg = response.bg
      this.form.indoor = response.indoor
      this.form.rid = response.rid
      this.form.lockEvent = response.lockEvent
      this.form.link = response.link
      this.location = response.location
      this.world = response.world
    },
    addLink () {
      let val = {}
      this.linkCondition.forEach((v)=>{
        val[v.key] = v.value
      })
      val.to = this.addLinkKey
      val.init = this.initPosKey
      this.form.link.push(val)
      this.addLinkKey = null
      this.linkCondition = []
      this.initPosKey = []
    },
    onSubmit () {
      this.$store.dispatch('setSpot', this.form)
        .then((response) => {
          this.postMessage = response
        })
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getSpot', route.params.id)
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  },
  watch: {
    addLinkKey () {
      this.initPosKeys = []
    }
  }
}
</script>

<style lang="scss" scoped>
.eno {
  position: relative;
  top: 20px;
  font-size: medium;
}
.action {
  margin: 3px;
}
#shout {
  .content {
    width: 100%;
  }
}
.link-world {
  overflow-x: scroll;

  table {
    width: 800px;
  }
}
</style>
